import { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { translations } from '@/lib/i18n';

const LanguageContext = createContext({ lang: 'en', setLang: () => {}, t: (k) => k });

const STORAGE_KEY = 'sbd_lang';

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState('en');

  useEffect(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
    if (saved === 'hi' || saved === 'en') setLangState(saved);
  }, []);

  const setLang = (next) => {
    setLangState(next);
    if (typeof window !== 'undefined') localStorage.setItem(STORAGE_KEY, next);
  };

  const value = useMemo(() => {
    const dict = translations[lang] || translations.en;
    const t = (key, fallback) => {
      const parts = key.split('.');
      let cur = dict;
      for (const p of parts) {
        if (cur && typeof cur === 'object' && p in cur) cur = cur[p];
        else return fallback ?? key;
      }
      return cur ?? fallback ?? key;
    };
    /** Pick the localized version of an object having `_en` and `_hi` suffixed fields. */
    const pickLocale = (obj, baseKey, fallback = '') => {
      if (!obj) return fallback;
      const hi = obj[`${baseKey}_hi`];
      const en = obj[`${baseKey}_en`];
      if (lang === 'hi' && hi) return hi;
      return en || hi || fallback;
    };
    return { lang, setLang, t, pickLocale };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
